import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { OrderModel, EstimateMark } from 'src/app/store/order/model';
import { AbstractOrderApiService } from 'src/app/core/services/abstract/abstract-order-api-service';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderFacade } from 'src/app/store/order/facade';

class Estimate {
  constructor(
    public order: OrderModel,
    public estimateMark: EstimateMark = null,
    public comment: string = null
  ) {}
}

class OrderPaging {
  public static readonly itemsInPage = 3;
  public pages: OrderModel[][] = [];
  public currentPage: number = 1;
}

class OrderPreview {
  public isShow: boolean = false;
  public order: OrderModel = null;
}

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.component.html',
  styleUrls: ['./notifications-page.component.scss'],
  standalone: false,
})
export class NotificationsPageComponent implements OnInit, OnChanges {
  private router = inject(Router);
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);

  @Input('caption') public caption: string;
  @Input('orders') public orders: OrderModel[];
  @Output('onClose') public onClose = new EventEmitter();

  public orderPaging: OrderPaging;
  public estimate: Estimate;

  public estimateMark = EstimateMark;
  public orderPreview: OrderPreview = new OrderPreview();

  public otherComment: boolean = false;

  ngOnInit(): void {
    this.orderPagingFill();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orders) {
      this.orderPagingFill();
    }
  }

  public orderPagingFill() {
    this.orderPaging = new OrderPaging();

    var page: number = 1;
    var items: OrderModel[] = [];

    this.orders?.forEach((x, i) => {
      items.push(x);
      if (i >= page * OrderPaging.itemsInPage - 1) {
        page = page + 1;
        this.orderPaging.pages.push(items);
        items = [];
      }
    });

    if (items.length > 0) {
      this.orderPaging.pages.push(items);
    }
  }

  public setEstimateOrder(order: OrderModel) {
    if (this.estimate?.order.id === order?.id) {
      this.estimate = null;
    } else {
      this.estimate = new Estimate(order);
    }
  }

  public onEstimateStarClick(estimateMark: EstimateMark) {
    this.otherComment = false;
    this.estimate.comment = '';

    if (this.estimate) {
      this.estimate.estimateMark = estimateMark;
    }
  }

  public nextPage(increase: boolean) {
    if (increase && this.orderPaging.currentPage < this.orderPaging.pages.length) {
      this.orderPaging.currentPage++;
    } else if (!increase && this.orderPaging.currentPage > 1) {
      this.orderPaging.currentPage--;
    }
  }

  public goToOrder(order: OrderModel) {
    this.hideOrderPreview();
    this.onClose.emit();
    this.router.navigate(['/orders/order', order.id]);
  }

  public clearEstimate() {
    this.estimate = null;
  }

  public sendEstimate(e) {
    let result = e.validationGroup.validate();

    if (result.isValid && this.estimate && this.estimate.order?.id) {
      let comment = this.estimate.comment ?? '';
      let checkedText = this.getCheckedText();

      if (checkedText != '') {
        comment = checkedText + (comment != '' ? '\n' + comment : '');
      }

      if (this.estimate.estimateMark == this.estimateMark.bad && comment == '') return;

      this.orderFacade.saveStatus(
        this.estimate.order.id,
        this.estimate.estimateMark,
        comment,
        [],
        OrderStatusConstants.OrderStatuses.Confirmed,
        false
      );
    }
  }

  public checkOtherCommentToggled(e) {
    this.otherComment = e.value;
  }

  public getCheckedText() {
    const checkedTextArray = [];
    const checkBoxes = document.querySelectorAll('.bad-box');
    const checkBoxesArray = Array.from(checkBoxes);

    checkBoxesArray.forEach((cb: HTMLElement) => {
      if (cb.ariaChecked == 'true') {
        checkedTextArray.push(cb.innerText);
      }
    });
    return checkedTextArray.join('\n');
  }

  orderPreviewClick(order: OrderModel) {
    if (this.orderPreview.isShow && this.orderPreview.order !== order) {
      this.orderPreview.order = order;
    } else {
      this.orderPreview.isShow = !this.orderPreview.isShow;
      this.orderPreview.order = this.orderPreview.isShow ? order : null;
    }
  }

  public hideOrderPreview() {
    this.orderPreview.order = null;
    this.orderPreview.isShow = false;
  }
}
